export default "/images/vendor/flag-icon-css/flags/1x1/tf.svg?aaea08de295f296f0bba198b214831ae";